/* eslint-disable camelcase */
export default function initPendoUser(
  { id, email, first_name, last_name, group_id, company_id },
  locationId = null,
) {
  const script = document.createElement('script');
  const pendoApiKey = import.meta.env.VITE_PENDO_API_KEY;
  script.src = `https://cdn.pendo.io/agent/static/${pendoApiKey}/pendo.js`;
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    const isReady = typeof window.pendo?.isReady === 'function' && window.pendo.isReady();

    if (!isReady) {
      window.pendo?.initialize({
        visitor: {
          id,
          email,
          full_name: `${first_name} ${last_name}`,
          role: group_id,
          hq_id: company_id,
          location_id: locationId,
        },
        account: {
          id: locationId || company_id,
          hq_id: company_id,
        },
      });
    } else {
      window.pendo?.updateOptions({
        visitor: {
          id,
          email,
          full_name: `${first_name} ${last_name}`,
          role: group_id,
          hq_id: company_id,
          location_id: locationId,
        },
        account: {
          id: locationId || company_id,
          hq_id: company_id,
        },
      });
    }
  };

  return () => {
    document.head.removeChild(script);
  };
}
